import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillDropdownSelectorV1FieldComponent } from './fill-dropdown-selector-v1/fill-dropdown-selector-v1.component';
import { ViewDropdownSelectorV1FieldComponent } from './view-dropdown-selector-v1/view-dropdown-selector-v1.component';
import { SettingsDropdownSelectorV1FieldComponent } from './settings-dropdown-selector-v1/settings-dropdown-selector-v1.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillDropdownSelectorV1FieldComponent,
        ViewDropdownSelectorV1FieldComponent,
        SettingsDropdownSelectorV1FieldComponent
    ],
    exports: [
        FillDropdownSelectorV1FieldComponent,
        ViewDropdownSelectorV1FieldComponent,
        SettingsDropdownSelectorV1FieldComponent
    ],

})
export class CoreCustomFormsFieldDropdownSelectorV1FieldsModule { }
